import React, { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useData } from '../context/DataContext';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getarchivedusers } from '../config/url';
import formatDate from '../utils/formatDate';

const ArchiveUsers = () => {
  const [render, setRender] = useState(null);
  const [currentUsers, setCurrentUsers] = useState(null);
  const [users, setUsers] = useState([]); // List of users
  const [search, setSearch] = useState(''); // Search input value
  const [filter, setFilter] = useState(''); // Filter value
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [usersPerPage] = useState(7); // Number of users per page

  // Dummy user data (replace with actual user data)
  const data = useFetchData(getarchivedusers, config);

  // Pagination
  useEffect(() => {
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    setCurrentUsers(users.slice(indexOfFirstUser, indexOfLastUser));
  }, [render]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Filter and search
  useEffect(() => {
    if (data) {
      let filteredUsers = data;

      if (filter === 'Sort by Membership') {
        filteredUsers = data.sort((a, b) =>
          a.membershipPlan > b.membershipPlan ? 1 : -1
        );
      } else if (filter === 'Sort by Join Date') {
        filteredUsers = data.sort((a, b) => (a.joinedOn > b.joinedOn ? 1 : -1));
      }

      if (search) {
        filteredUsers = filteredUsers.filter((user) =>
          Object.values(user)
            .join(' ')
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }

      setUsers(filteredUsers);
      setRender(Math.floor(Math.random() * 10));
    }
  }, [search, filter, data]);
  const navigate = useNavigate();
  return (
    <div className='container'>
      <div className='d-flex justify-content-end align-items-center'>
        {/* <div>
          <Button variant='primary'>Add User</Button>
        </div> */}
        {data != null ? (
          <div className='d-flex'>
            <div className='me-2'>
              <input
                type='text'
                className='form-control rounded'
                placeholder='Search by Name'
                style={{ maxWidth: '300px' }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <select
                className='form-select'
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value=''>Select Filter</option>
                <option value='Sort by Membership'>Sort by Membership</option>
                <option value='Sort by Join Date'>Sort by Join Date</option>
              </select>
            </div>
          </div>
        ) : null}
      </div>
      <div className='bg-white my-4 rounded shadow'>
        {data != null ? (
          <Table
            responsive='xl'
            className='table table-hover mb-4'
            style={{ borderCollapse: 'separate', borderSpacing: '0 1rem' }}
          >
            <thead className='bg-light'>
              <tr>
                <th>Name</th>
                <th>DOB</th>
                <th>State</th>
                <th>Join Date</th>
                <th>Membership</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user) => (
                <tr key={user._id}>
                  <td>
                    {user.firstName}
                    {' ' + user.lastName}
                  </td>
                  <td>{formatDate(user.dob)}</td>
                  <td>{user.state}</td>
                  <td>{formatDate(user.joinedOn)}</td>
                  <td>{user.membershipPlan}</td>
                  <td>
                    <Button
                      variant='secondary'
                      size='md'
                      onClick={() => navigate(`/users/${user.id}`)}
                    >
                      <BsThreeDots />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <h4 className='h4 mt-4 mb-4'>Fetching data...</h4>
        )}
      </div>
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={users.length}
        rowsPerPage={usersPerPage}
        onPageChange={paginate}
      />
    </div>
  );
};

export default ArchiveUsers;
